import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection.js";

let APL_LINK = "http://192.168.1.50:8000/";

APL_LINK = "http://127.0.0.1:8000/";
APL_LINK = "https://backendpython.uprestro.com/";
let version_vi_api_restaurant = APL_LINK + "api/v1/restaurant/";
// API functions
const SECRET_KEY = "UPRESTRO_POS_202";
const save_update_units = version_vi_api_restaurant + "save_update_units";
const save_update_conversion_rule =
  version_vi_api_restaurant + "save_update_conversion_rule";
const get_view_units = version_vi_api_restaurant + "get_view_units";

const show_hide_unit = version_vi_api_restaurant + "show_hide_unit";
const get_department_with_categories =
  version_vi_api_restaurant + "get_department_with_categories";
const get_item_acc_to_department_master_data =
  version_vi_api_restaurant + "get_item_acc_to_department_master_data";
const get_recipes_as_ingredients =
  version_vi_api_restaurant + "get_recipes_as_ingredients";
const get_vendor_list = version_vi_api_restaurant + "get_vendor_list";
const get_vendor_master_data =
  version_vi_api_restaurant + "get_vendor_master_data";
const save_update_vendor = version_vi_api_restaurant + "save_update_vendor";
const delete_vendor = version_vi_api_restaurant + "delete_vendor";
const get_kitchen_request_list =
  version_vi_api_restaurant + "get_kitchen_request_list";
const get_kitchen_master_data =
  version_vi_api_restaurant + "get_kitchen_master_data";
const kitchen_raise_item_request =
  version_vi_api_restaurant + "kitchen_raise_item_request";
const get_store_issue_list = version_vi_api_restaurant + "get_store_issue_list";
const store_issue_items = version_vi_api_restaurant + "store_issue_items";
const get_kot_modification_report =
  version_vi_api_restaurant + "get_kot_modification_report";

const get_purchase_list = version_vi_api_restaurant + "get_purchase_list";
const get_purchase_master_data =
  version_vi_api_restaurant + "get_purchase_master_data";
const save_update_purchase = version_vi_api_restaurant + "save_update_purchase";
const grn_dashboard_list = version_vi_api_restaurant + "grn_dashboard_list";
const get_grn_by_purchase_id =
  version_vi_api_restaurant + "get_grn_by_purchase_id";
const save_grn_verify = version_vi_api_restaurant + "save_grn_verify";
const restore_grn = version_vi_api_restaurant + "restore_grn";
const get_view_ingredients = version_vi_api_restaurant + "get_view_ingredients";
const get_view_stock_inventory =
  version_vi_api_restaurant + "get_view_stock_inventory";
const get_dashboard_data = version_vi_api_restaurant + "get_dashboard_data";
const save_update_ingredients =
  version_vi_api_restaurant + "save_update_ingredients";
const show_hide_ingredients =
  version_vi_api_restaurant + "show_hide_ingredients";
const login_to_pos = version_vi_api_restaurant + "login_to_pos";

const save_update_department_with_categories =
  version_vi_api_restaurant + "save_update_department_with_categories";
const delete_department_with_categories =
  version_vi_api_restaurant + "delete_department_with_categories";
const get_store_issue_by_id =
  version_vi_api_restaurant + "get_store_issue_by_id";
const get_pending_po_for_owner =
  version_vi_api_restaurant + "get_owner_po_approval_history";
const owner_reject_po = version_vi_api_restaurant + "owner_reject_po";
const get_reservations = version_vi_api_restaurant + "get_reservations";
const owner_approve_po = version_vi_api_restaurant + "owner_approve_po";
const get_tv_dashboard = version_vi_api_restaurant + "get_tv_dashboard";
const get_grn_report = version_vi_api_restaurant + "get_grn_report";
const payment_summary_report =
  version_vi_api_restaurant + "payment_summary_report";
const get_kitchen_indent_report =
  version_vi_api_restaurant + "get_kitchen_indent_report";
const get_owner_po_approval_history =
  version_vi_api_restaurant + "get_owner_po_approval_history";
const import_ingredients_from_csv =
  version_vi_api_restaurant + "import_ingredients_from_csv";
const get_view_category = version_vi_api_restaurant + "get_view_category";
const save_update_category = version_vi_api_restaurant + "save_update_category";
const show_hide_menu = version_vi_api_restaurant + "show_hide_menu";
const generate_qr_string = version_vi_api_restaurant + "generate_qr_string";
const delete_menu_data = version_vi_api_restaurant + "delete_menu_data";
const get_all_veriation_res =
  version_vi_api_restaurant + "get_all_veriation_res";
const save_variation = version_vi_api_restaurant + "save_variation";
const get_addon_data_res = version_vi_api_restaurant + "get_addon_data_res";
const save_update_addon = version_vi_api_restaurant + "save_update_addon";
const get_view_menu = version_vi_api_restaurant + "get_view_menu";
const get_all_areas_res = version_vi_api_restaurant + "get_all_areas_res";
const toggle_show_hide_area_res =
  version_vi_api_restaurant + "toggle_show_hide_area_res";
const delete_area_res = version_vi_api_restaurant + "delete_area_res";
const get_all_tables_res = version_vi_api_restaurant + "get_all_tables_res";
const save_update_table = version_vi_api_restaurant + "save_update_table";
const toggle_show_hide_res = version_vi_api_restaurant + "toggle_show_hide_res";
const delete_table_res = version_vi_api_restaurant + "delete_table_res";
const get_all_menu = version_vi_api_restaurant + "get_all_menu";
const save_update_menu = version_vi_api_restaurant + "save_update_menu";
const save_update_dine_area =
  version_vi_api_restaurant + "save_update_dine_area";
const get_waiter_staff = version_vi_api_restaurant + "get_waiter_staff";
const upload_menu_by_csv = version_vi_api_restaurant + "upload_menu_by_csv";
const get_printer_configurations =
  version_vi_api_restaurant + "get_printer_configurations";
const get_crm = version_vi_api_restaurant + "get_crm";
const crm_save_update = version_vi_api_restaurant + "crm_save_update";

const dayend_report = version_vi_api_restaurant + "dayend_report";
const order_wise_kot_report =
  version_vi_api_restaurant + "order_wise_kot_report";
const get_sales_reports_res =
  version_vi_api_restaurant + "get_sales_reports_res";
const get_tip_reports = version_vi_api_restaurant + "get_tip_reports";
const get_order_biller = version_vi_api_restaurant + "get_order_biller";
const get_all_staff_captain =
  version_vi_api_restaurant + "get_all_staff_captain";
const get_discount_reports = version_vi_api_restaurant + "get_discount_reports";
const get_complimentary_reports =
  version_vi_api_restaurant + "get_complimentary_reports";
const get_all_taxes = version_vi_api_restaurant + "get_all_taxes";
const item_wise_sales_report =
  version_vi_api_restaurant + "item_wise_sales_report";
const action_update_res_staff =
  version_vi_api_restaurant + "action_update_res_staff";
const save_update_staff_res =
  version_vi_api_restaurant + "save_update_staff_res";
const get_designation_list = version_vi_api_restaurant + "get_designation_list";
const saveupdate_designtion =
  version_vi_api_restaurant + "saveupdate_designtion";
const saveupdatenew_designtion =
  version_vi_api_restaurant + "saveupdatenew_designtion";

const save_update_taxes = version_vi_api_restaurant + "save_update_taxes";
const accept_zomato_booking =
  version_vi_api_restaurant + "accept_zomato_booking";
const reject_zomato_booking =
  version_vi_api_restaurant + "reject_zomato_booking";
const cancel_zomato_booking =
  version_vi_api_restaurant + "cancel_zomato_booking";
const zomato_slot_action = version_vi_api_restaurant + "zomato_slot_action";
const get_zomato_blocked_slots =
  version_vi_api_restaurant + "get_zomato_blocked_slots";
const get_zomato_cancelled_bookings =
  version_vi_api_restaurant + "get_zomato_cancelled_bookings";

const get_all_restaurant_from_staff =
  version_vi_api_restaurant + "get_all_restaurant_from_staff";
const action_change_restaurant_token =
  version_vi_api_restaurant + "action_change_restaurant_token";

const save_update_printer_config =
  version_vi_api_restaurant + "save_update_printer_config";

const save_restaurant_setting =
  version_vi_api_restaurant + "save_restaurant_setting";

const get_restaurant_setting =
  version_vi_api_restaurant + "get_restaurant_setting";

const get_all_staff_rights = version_vi_api_restaurant + "get_all_staff_rights";
const save_update_staff_rights =
  version_vi_api_restaurant + "save_update_staff_rights";
const action_staff_right = version_vi_api_restaurant + "action_staff_right";

const get_view_receipt = version_vi_api_restaurant + "get_view_receipt";
const get_ingredients = version_vi_api_restaurant + "get_ingredients";
const get_recipe_details = version_vi_api_restaurant + "get_recipe_details";
const save_update_receipe = version_vi_api_restaurant + "save_update_receipe";
const save_update_audit = version_vi_api_restaurant + "save_update_audit";
const get_audit_list = version_vi_api_restaurant + "get_audit_list";
const get_adjustment_list = version_vi_api_restaurant + "get_adjustment_list";
const save_update_adjustment =
  version_vi_api_restaurant + "save_update_adjustment";
const view_category_printer_mappings =
  version_vi_api_restaurant + "view_category_printer_mappings";
const save_update_category_printer_mapping =
  version_vi_api_restaurant + "save_update_category_printer_mapping";
const delete_category_printer_mapping =
  version_vi_api_restaurant + "delete_category_printer_mapping";
const delete_printer = version_vi_api_restaurant + "delete_printer";
const logout_staff = version_vi_api_restaurant + "logout_staff";
const logout_single_staff = version_vi_api_restaurant + "logout_single_staff";
const get_customer_wise_report =
  version_vi_api_restaurant + "get_customer_wise_report";
const get_invoice_sales_report =
  version_vi_api_restaurant + "get_invoice_sales_report";
const get_order_modification_report =
  version_vi_api_restaurant + "get_order_modification_report";
const save_update_combo_rule =
  version_vi_api_restaurant + "save_update_combo_rule";
const view_combo_rules = version_vi_api_restaurant + "view_combo_rules";
const get_operational_timings =
  version_vi_api_restaurant + "get_operational_timings";
const save_operational_timings =
  version_vi_api_restaurant + "save_operational_timings";

const delete_recipe =
  version_vi_api_restaurant + "delete_recipe";
const show_hide_recipe =
  version_vi_api_restaurant + "show_hide_recipe";
// ==================== Report API Endpoints ====================

const get_stock_ledger_report =
  version_vi_api_restaurant + "get_stock_ledger_report";
const get_stock_summary_report =
  version_vi_api_restaurant + "get_stock_summary_report";
const get_stock_issue_report =
  version_vi_api_restaurant + "get_stock_issue_report";
const get_audit_report = version_vi_api_restaurant + "get_audit_report";
const get_adjustment_report =
  version_vi_api_restaurant + "get_adjustment_report";
const get_purchase_order_report =
  version_vi_api_restaurant + "get_purchase_order_report";
const get_indent_report = version_vi_api_restaurant + "get_indent_report";
const get_consumption_report =
  version_vi_api_restaurant + "get_consumption_report";
const get_recipe_costing_report =
  version_vi_api_restaurant + "get_recipe_costing_report";
// Common Filter API
const get_report_filter_data =
  version_vi_api_restaurant + "get_report_filter_data";
// ------------------------------------------------------- restaurant End------------------------------------------------------------------------
const logoutAndClearData = () => {
  // Clear all stored data
  localStorage.clear();
  sessionStorage.clear();

  // Optional: redirect to login page
  window.location.href = "/"; // apna login route yahan daalein
};
const server_post_data = async (url_for, form_data, default_database_name) => {
  try {
    let packageName_new = retrieveData("packageName"); // Use `let` instead of `const`

    const retrievedAdminId = retrieveData("admin_id");
    const retrievedRestaurantId = retrieveData("default_restaurant_id");
    const access_token = retrieveData("access_token");
    let packageName = packageName_new;
    if (!default_database_name) {
      // Simplified check for undefined, null, or empty string
      packageName = packageName_new;
    } else {
      packageName = default_database_name;
    }
    if (packageName === "1" || packageName === 1 || login_to_pos === url_for) {
      packageName = "Default";
    }
    if (form_data === null) {
      form_data = new FormData();
    }
    form_data.append("admin_id", retrievedAdminId);
    form_data.append("default_restaurant_id", retrievedRestaurantId);
    form_data.append("platform_type", "panel");
    form_data.append("app_name", "RestaurantWeb");
    if (form_data.get("data_call") !== null) {
      form_data.append("call_id", retrievedAdminId);
    }
    // console.log("packageName", packageName);
    const response = await axios.post(url_for, form_data, {
      headers: {
        "X-Package-Name": packageName,
        ...(access_token &&
          access_token !== "1" &&
          url_for !== login_to_pos && {
            Authorization: `Bearer ${access_token}`,
          }),
      },
    });
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Session expired. Logging out...");
      logoutAndClearData();
    }

    throw error;
  }
};

export {
  APL_LINK,
  SECRET_KEY,
  get_view_units,
  save_update_units,
  show_hide_unit,
  save_update_conversion_rule,
  login_to_pos,
  save_update_department_with_categories,
  get_department_with_categories,
  get_item_acc_to_department_master_data,
  get_vendor_list,
  get_vendor_master_data,
  save_update_vendor,
  delete_vendor,
  get_kitchen_request_list,
  get_kitchen_master_data,
  kitchen_raise_item_request,
  get_store_issue_list,
  store_issue_items,
  get_purchase_list,
  get_purchase_master_data,
  save_update_purchase,
  grn_dashboard_list,
  get_grn_by_purchase_id,
  get_grn_report,
  get_kitchen_indent_report,
  save_grn_verify,
  delete_department_with_categories,
  restore_grn,
  get_view_ingredients,
  save_update_ingredients,
  show_hide_ingredients,
  get_store_issue_by_id,
  get_view_stock_inventory,
  get_dashboard_data,
  get_tv_dashboard,
  server_post_data,
  get_view_category,
  get_all_taxes,
  save_update_category,
  show_hide_menu,
  delete_menu_data,
  get_all_veriation_res,
  save_variation,
  get_addon_data_res,
  save_update_addon,
  get_view_menu,
  upload_menu_by_csv,
  save_update_menu,
  get_all_menu,
  action_update_res_staff,
  get_all_staff_captain,
  save_update_staff_res,
  get_designation_list,
  saveupdate_designtion,
  saveupdatenew_designtion,
  save_update_taxes,
  save_update_printer_config,
  get_printer_configurations,
  save_restaurant_setting,
  get_restaurant_setting,
  get_all_areas_res,
  toggle_show_hide_area_res,
  delete_area_res,
  get_all_tables_res,
  toggle_show_hide_res,
  delete_table_res,
  save_update_table,
  save_update_dine_area,
  get_waiter_staff,
  get_all_staff_rights,
  save_update_staff_rights,
  action_staff_right,
  get_crm,
  crm_save_update,
  dayend_report,
  owner_reject_po,
  owner_approve_po,
  get_pending_po_for_owner,
  get_sales_reports_res,
  order_wise_kot_report,
  item_wise_sales_report,
  get_tip_reports,
  get_discount_reports,
  get_view_receipt,
  get_owner_po_approval_history,
  get_order_biller,
  get_ingredients,
  get_recipe_details,
  save_update_receipe,
  import_ingredients_from_csv,
  save_update_audit,
  save_update_adjustment,
  get_audit_list,
  get_adjustment_list,
  get_all_restaurant_from_staff,
  action_change_restaurant_token,
  view_category_printer_mappings,
  save_update_category_printer_mapping,
  delete_category_printer_mapping,
  delete_printer,
  generate_qr_string,
  logout_staff,
  logout_single_staff,
  get_customer_wise_report,
  get_invoice_sales_report,
  get_order_modification_report,
  get_reservations,
  save_update_combo_rule,
  accept_zomato_booking,
  reject_zomato_booking,
  cancel_zomato_booking,
  zomato_slot_action,
  get_zomato_blocked_slots,
  get_zomato_cancelled_bookings,
  view_combo_rules,
  get_recipes_as_ingredients,
  get_kot_modification_report,
  get_operational_timings,
  save_operational_timings,
  get_complimentary_reports,
  payment_summary_report,
  get_stock_ledger_report,
  get_stock_summary_report,
  get_stock_issue_report,
  get_audit_report,
  get_adjustment_report,
  get_purchase_order_report,
  get_indent_report,
  get_consumption_report,
  get_recipe_costing_report,
  get_report_filter_data,
  delete_recipe,
  show_hide_recipe
};
